import React, { useEffect, useState } from "react";
import "./AddNewProduct.css";
import AddNewProductHeadingSection from "./AddNewProductHeadingSection/AddNewProductHeadingSection";
import { useDispatch, useSelector } from "react-redux";
import objectHash from "object-hash";
import { useNavigate } from "react-router-dom";
import { productsActions } from "../../../../../store/products-slice";
import UNIVERSAL from "../../../../../config/config";
import { useMutation } from "react-query";
import { api } from "../../../../../config/api";
import { PuffLoader } from "react-spinners";
import { stepsActions } from "../../../../../store/steps-slice";
import { toast } from "react-toastify";

const AddNewProduct = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);
  const editProduct = useSelector((state) => state.products.editProduct);
  const redirected = useSelector((state) => state.steps.redirected);

  const stepNo = useSelector((state) => state.steps.stepNumber);

  const navigate = useNavigate();

  const [s3Image, setS3Image] = useState([]);
  const [imageFile, setImageFile] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [imageFileName, setImageFileName] = useState([]);

  const [currency, setCurrency] = useState(editProduct ? editProduct.currency : "INR");
  const [addNewProductData, setAddNewProductData] = useState({
    name: editProduct ? editProduct.name : "",
    price: editProduct ? editProduct.selling_price : "",
    description: editProduct ? editProduct.description : "",
  });

  const [websiteScrapedData, setWebsiteScrapedData] = useState({
    url: "",
  });

  function handleAddNewProductData(event) {
    const { name, value } = event.target;
    setAddNewProductData((prevData) => {
      return { ...prevData, [name]: value };
    });
  }

  function handleImageFile(event) {
    if (imageFile.length > 4) {
      return;
    } else {
      let files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const types = ["image/webp", "image/svg+xml", "image/png", "image/jpeg"];
        if (!types.includes(files[i].type)) {
          continue;
        }
        setImageFileName((prevData) => {
          return [...prevData, files[i].name];
        });
      }
      let file;
      for (let i = 0; i < files.length; i++) {
        const types = ["image/webp", "image/svg+xml", "image/png", "image/jpeg"];
        if (!types.includes(files[i].type)) {
          toast("Files with unsupported formats have been removed. Only PNG, JPEG, SVG and WEBP files are supported.", { type: "error" });
          continue;
        }
        let reader = new FileReader();
        file = files[i];
        reader.onload = (file) => {
          setImageFile((prevData) => {
            return [...prevData, reader.result];
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  function dragOver(e) {
    e.preventDefault();
  }

  function dragEnter(e) {
    e.preventDefault();
  }

  function dragLeave(e) {
    e.preventDefault();
  }

  function fileDrop(e) {
    e.preventDefault();
    if (imageFile.length > 5) {
      return;
    } else {
      let files = e.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        setImageFileName((prevData) => {
          return [...prevData, files[i].name];
        });
      }
      let file;
      for (let i = 0; i < files.length; i++) {
        let reader = new FileReader();
        file = files[i];
        reader.onload = (file) => {
          setImageFile((prevData) => {
            return [...prevData, reader.result.toString()];
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  useEffect(() => {
    const newImageFileData = [];
    for (let i = 0; i < imageFile.length; i++) {
      newImageFileData.push({ filename: imageFileName[i], image: imageFile[i] });
    }
    setImageData(newImageFileData);
  }, [imageFile]);

  function handleRemoveImage(id) {
    const newData = [...imageFile];
    const filterData = newData.filter((data, index) => {
      return index !== id;
    });
    setImageFile(filterData);
    const newFileNameData = [...imageFileName];
    const filterFileData = newFileNameData.filter((data, index) => {
      return index !== id;
    });
    setImageFileName(filterFileData);

    const newS3FileData = [...s3Image];
    const filterS3FileData = newS3FileData.filter((data, index) => {
      return index !== id;
    });
    setS3Image(filterS3FileData);
  }

  useEffect(() => {
    if (imageData) {
      for (let i = 0; i < imageData.length; i++) {
        async function getImageS3Url() {
          return fetch(UNIVERSAL.BASEURL_1 + "/internal/upload_image", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
            },
            body: JSON.stringify({
              filename: imageData[i].filename,
              image: imageData[i].image.substring(22),
            }),
          })
            .then((response) => response.json())
            .then((responseJson) => {
              if (responseJson) {
                if (s3Image.includes(responseJson.url)) {
                  return;
                } else {
                  if (responseJson.url) {
                    setS3Image((prevData) => {
                      return [...prevData, responseJson.url];
                    });
                  }
                }
              } else {
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
        getImageS3Url();
      }
    }
  }, [imageData]);

  async function handleAddNewproduct(event) {
    event.preventDefault();
    if (!imageFile.length > 0 || !addNewProductData.name || !addNewProductData.description || !addNewProductData.price) {
      return;
    } else if (editProduct) {
      let media = [];
      for (let i = 0; i < s3Image.length; i++) {
        media.push({ type: "IMAGE", url: s3Image[i] });
      }
      return fetch(UNIVERSAL.BASEURL_1 + "/product/updateProduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          productId: editProduct?.product_id.toString(),
          name: addNewProductData.name,
          description: addNewProductData.description,
          product_promotion_tags: [],
          media: media,
          currency: currency,
          basePrice: addNewProductData.price,
          tax: 18,
          mrp: addNewProductData.price,
          sellingPrice: addNewProductData.price,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data) {
            console.log(responseJson.data);
            dispatch(productsActions.setEditProductDetails(null));
            navigate("/products");
          } else {
            // error
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      let media = [];
      for (let i = 0; i < s3Image.length; i++) {
        media.push({ type: "IMAGE", url: s3Image[i] });
      }
      return fetch(UNIVERSAL.BASEURL_1 + "/product/addProduct", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          businessId: user?.app_business_id.toString(),
          sku: objectHash(addNewProductData.name),
          name: addNewProductData.name,
          description: addNewProductData.description,
          product_promotion_tags: [],
          media: media,
          currency: currency,
          basePrice: addNewProductData.price,
          tax: 18,
          mrp: addNewProductData.price,
          sellingPrice: addNewProductData.price,
          stage: false,
          is_campaign_mapped: false,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data) {
            if (redirected) {
              dispatch(stepsActions.handleStepNumber(3));
              dispatch(stepsActions.step2({ ...responseJson?.data?.[0] }));
              const productId = responseJson?.data?.[0]?.product_id;
              navigate(`/create-campaign?selectedProduct=${productId}`);
            } else {
              toast("Product added successfully", { type: "success" });
              navigate("/products");
            }
          } else {
            toast(responseJson.message ?? "Unable to add product. Please try again.", { type: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  useEffect(() => {
    if (editProduct) {
      let data = [];
      for (let i = 0; i < editProduct.media.length; i++) {
        data.push(editProduct.media[i].url);
      }
      setImageFile(data);
      setS3Image(data);
    }
  }, [editProduct]);

  const scrapeWebsite = useMutation({
    mutationFn: async (image) => {
      const response = await api.post("/products/api/v1/scrape", { image, business_id: user.app_web_business_id });
      return response.data.data;
    },
  });

  async function handleScrapeWebsite(event) {
    event.preventDefault();
    if (!websiteScrapedData.url || !websiteScrapedData.url.length) return alert("Please provide the website url");
    const data = await scrapeWebsite.mutateAsync(websiteScrapedData.url);
    setWebsiteScrapedData((state) => ({ ...state, ...data }));
    setAddNewProductData((state) => ({ ...state, name: data.product_name, description: data.product_description, price: data.product_selling_price }));
  }

  return (
    <div id="addNewProduct">
      <AddNewProductHeadingSection redirected={redirected} />
      <div>
        <form onSubmit={handleAddNewproduct}>
          <div className="addNewProductContainer">
            <h2 className="addNewProductContainer-heading">Please enter these details</h2>
            <hr className="stepsHr" />
            <div className="scanUrlDiv">
              <div className="addNewProduct-formFields">
                <div class="mb-3 websiteScapUrlInput">
                  <input
                    type="text"
                    class="form-control addNewProduct-inputTextField websiteScapUrlInputField"
                    id="exampleFormControlInput1"
                    placeholder="Website URL"
                    name="name"
                    value={websiteScrapedData.url}
                    onChange={(e) => setWebsiteScrapedData((state) => ({ ...state, url: e.target.value }))}
                  />
                  <label for="exampleFormControlInput1" class="form-label" style={{ marginLeft: "5px" }}>
                    Please provide the URL of the product. (e.g., zocket.com/product/ads).
                  </label>
                </div>
              </div>
              <button className="scanUrlButton" type="submit" disabled={scrapeWebsite.isLoading} onClick={handleScrapeWebsite}>
                Scan the URL
                {scrapeWebsite.isLoading && <PuffLoader size={30} color="#0F6EFF" />}
              </button>
            </div>
            <div className="creativeForm__line">
              <hr />
              or enter these details manually
              <hr />
            </div>
            <div className="addNewProductDetailsForm">
              <div className="addNewProduct-formFields">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">
                    Product or Service name
                  </label>
                  <input
                    type="text"
                    class="form-control addNewProduct-inputTextField"
                    id="exampleFormControlInput1"
                    placeholder="Blueberry cake with toppings"
                    name="name"
                    value={addNewProductData.name}
                    onChange={handleAddNewProductData}
                    required
                  />
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput2" class="form-label">
                    Enter Price
                  </label>
                  <div className="input-group addNewProduct-inputGroup2">
                    <button class="btn btn-outline-secondary dropdown-toggle addNewProduct-inputTextFieldDropDown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      {currency}
                    </button>
                    <ul class="dropdown-menu">
                      <li onClick={() => setCurrency("INR")}>
                        <a class="dropdown-item">INR</a>
                      </li>
                      <li onClick={() => setCurrency("USD")}>
                        <a class="dropdown-item">USD</a>
                      </li>
                    </ul>
                    <input
                      type="number"
                      class="form-control addNewProduct-inputTextField2"
                      aria-label="Text input with dropdown button"
                      placeholder="4,099"
                      id="exampleFormControlInput2"
                      name="price"
                      value={addNewProductData.price}
                      onChange={handleAddNewProductData}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="addNewProduct-formFields">
                <div class="mb-3">
                  <label for="exampleFormControlTextarea1" class="form-label">
                    Product or Service description
                  </label>
                  <textarea
                    class="form-control addNewProduct-inputTextAreaField"
                    id="exampleFormControlTextarea1"
                    placeholder="A sweet, baked, breadlike food, made with or without shortening and usually containing flour."
                    name="description"
                    value={addNewProductData.description}
                    onChange={handleAddNewProductData}
                    required
                  ></textarea>
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlTextarea1" class="form-label">
                    Product or Service images
                  </label>
                  <div className="addNewProduct-imageUpload" onDragOver={dragOver} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={fileDrop}>
                    <div className="addNewProduct-imageUpload-div">
                      <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/upload.svg" alt="upload-img" />
                      <div className="addNewProduct-imageUploadContent">
                        <div className="addNewProduct-imageUploadContentHeading">
                          <h4 className="addNewProduct-imageUploadContentHeadingText">Drag and Drop your file here or</h4>
                        </div>
                        <p className="addNewProduct-imageUploadContentSubHeading">Supports jpg, jpeg, png, svg and webp</p>
                      </div>
                      <div className="addNewProduct-imageUploadContentHeading-imgUploadDiv">
                        <label className="addNewProduct-imageUploadContentHeading-imguploadBtnText" for="file-upload">
                          Browse files
                        </label>
                        <input
                          id="file-upload"
                          type="file"
                          className="addNewProduct-imageUploadContentHeading-imguploadBtn"
                          name="imageFile"
                          onChange={(e) => handleImageFile(e)}
                          multiple
                        />
                      </div>
                    </div>
                    {imageFile && (
                      <div className="addNewProduct-userSelectedImage">
                        {((editProduct && editProduct.media.length > 0) || imageFile.length > 0) && <p className="userSelectedImageHeading">Uploaded files</p>}
                        <div className="userSelectedImages">
                          {s3Image &&
                            s3Image.map((img, index) => {
                              return (
                                <div className="userSelectedImage" key={index}>
                                  <img className="userSelectedImg" src={img} alt="user-product-img" />
                                  <img
                                    className="removeImage"
                                    src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/removeProductImage.svg"
                                    alt="remove-product-icon"
                                    onClick={() => handleRemoveImage(index)}
                                  />
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="addUpdateProductBtnDiv">
            <button
              className={`addUpdateProductBtn ${
                addNewProductData?.name && addNewProductData?.description && addNewProductData?.price && s3Image.length > 0
                  ? "addUpdateProductEnableBtn"
                  : "addUpdateProductDisableBtn"
              }`}
              type="submit"
              disabled={
                (!addNewProductData?.name && !addNewProductData?.description && !addNewProductData?.price && !s3Image) ||
                (!editProduct?.name && !editProduct?.description && !editProduct?.selling_price && !s3Image)
              }
            >
              {editProduct ? "Update Product" : "Add this product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewProduct;
